export const COLUMN_WIDTH = {
  SEND_ON_DATE: 190,
  DELIVERY_STATUS: 200,
} as const
